<template>
<v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
      :top="'top'"
    >
      {{ text }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
</template>


<script>

    export default{
        data(){
            return{
                snackbar: false,
                color: '',
                mode: '',
                timeout: 6000,
                text: 'Hello, I\'m a snackbar'
        }
           
      
        }
    }

</script>